import { cleanObject } from "../helpers";
import axiosInstance from "./baseUrl";

export const getCourierOffice = async (parameters: any) => {
  const params = cleanObject(parameters);
  const response = await axiosInstance.get("/v1/currier/list_courier_office", {
    params,
  });
  return response.data;
};

export const calculateCourierFee = async (feeDetails: any) => {
  const response = await axiosInstance.post(
    "/v1/currier/calculate_courier_fee",
    feeDetails
  );
  return response.data;
};

export const viewCourierFeeConfig = async (feeId: any) => {
  const response = await axiosInstance.get(
    "/v1/currier/view_courier_fee_config",
    { params: { id: feeId } }
  );
  return response.data;
};

export const configureCourierFee = async (feeDetails: any) => {
  const response = await axiosInstance.post(
    "/v1/currier/configure_courier_fee",
    feeDetails
  );
  return response.data;
};

export const createCourierOffice = async (officeDetails: any) => {
  const response = await axiosInstance.post(
    "/v1/currier/create_courier_office",
    officeDetails
  );
  return response.data;
};

export const editCourierOffice = async (parameters: any) => {
  const response = await axiosInstance.put(
    `/v1/currier/update_courier_office/${parameters.branchId}`,
    parameters?.branchDetails
  );
  return response.data;
};

export const toggleCourierOFficeStatus = async (
  branchId: any,
  isEnabled: any
) => {
  const response = await axiosInstance.put(
    `/v1/currier/toggle_courier_office_status/${branchId}`,
    { isEnabled }
  );
  return response.data;
};

export const viewCurrier = async (courierId: any) => {
  const response = await axiosInstance.get(
    `/v1/currier/view_currier/${courierId}`
  );
  return response.data;
};

export const getAllCurrier = async (parameters?: any) => {
  const response = await axiosInstance.get("/v1/currier/list_currier", {
    params: parameters,
  });
  return response.data;
};

export const createCurrier = async (currierDetails: any) => {
  const response = await axiosInstance.post(
    "/v1/currier/create_currier",
    currierDetails
  );
  return response.data;
};

export const getCurrierAgents = async (parameters: any) => {
  const response = await axiosInstance.get(
    `/v1/currier/list_courier_agents/${parameters?.courierId}`,
    {
      params: parameters,
    }
  );
  return response.data;
};

export const deleteCurrier = async (courierId: any) => {
  const response = await axiosInstance.delete(
    `/v1/currier/delete_currier/${courierId}`,
    { params: { id: courierId } }
  );
  return response.data;
};

export const editCurrier = async (courierId: string, currierDetails: any) => {
  const response = await axiosInstance.put(
    `/v1/currier/edit_currier/${courierId}`,
    currierDetails,
    { params: { id: courierId } }
  );
  return response.data;
};
